import Repository from '@/app/shared/infrastructure/http/Repository';

export default class BillReceivableRepository extends Repository {
    uri = '/api/bills-receivable';

    async receive(id: string) {
        return await this.client.put(`${this.uri}/${id}/receive`, {});
    }
}
